module.exports = "/assets/images/4a6b8b49f0c42925362ab2626473737e.svg";